import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityCommentService {
   PATH = "/appliances/api/v2/activity-comment"

  constructor(private httpClient:HttpClient) { }


  getActivityComments(activityId: any) :any {

      const token = localStorage.getItem("token");
      const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    return this.httpClient.get<any>(`${this.PATH}/activity/${activityId}` , { headers })
      .pipe(catchError(this.errorHandler));
  }

  saveActivityComment(comment: any) :any {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.post(`${this.PATH}/save-comment`, comment, { headers })
      .pipe(catchError(this.errorHandler));
  }
 

    
    errorHandler(error: HttpErrorResponse) {
      console.log(error.message);
      return throwError(error.message || 'Server Error');
  
    }

   
}
